import _ from "lodash";
export default (state: tcpinpoint.Tenant[] = [], action: any) => {
	switch (action.type) {
		case "GET_TENANT_SUCCESS":
			return _.unionBy([action.resource as tcpinpoint.Tenant], state, "id");
		case "GET_TENANTS_SUCCESS":
			return _.unionBy(action.resource as tcpinpoint.Tenant[], state, "id");
		case "CLEAR_SESSION":
			return [];
		default:
			return state;
	}
};
